import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";

type Props = {
	label: string;
	onClick: () => void;
	truncate?: boolean;
};

export const ActionRow = ({ label, onClick, truncate = false }: Props) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			justifyContent="space-between"
			alignItems="center"
			onClick={onClick}
			bgcolor={theme.palette.deprecated.grey[50]}
			borderRadius={theme.radii.lg}
			sx={{ cursor: "pointer" }}
			px={1.6}
			py={1.2}
		>
			<Typography
				variant="deprecatedBody1"
				color={theme.palette.deprecated.grey[700]}
				flexGrow={1}
				sx={{
					...(truncate
						? {
								whiteSpace: "nowrap",
								overflow: "hidden",
								textOverflow: "ellipsis",
							}
						: {
								whiteSpace: "normal",
								overflowWrap: "break-word",
							}),
				}}
			>
				{label}
			</Typography>
			<ChevronRight
				size={theme.iconSize.sm}
				color={theme.palette.primary.main}
			/>
		</Stack>
	);
};
